import { render, staticRenderFns } from "./BlockMod.vue?vue&type=template&id=25d64ad2&scoped=true"
import script from "./BlockMod.vue?vue&type=script&lang=js"
export * from "./BlockMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d64ad2",
  null
  
)

export default component.exports